import { appConfig } from 'brand-config';

import portal from 'core/assets/svg/portal.svg';
import contact from 'core/assets/svg/contact.svg';
import pen from 'core/assets/svg/pen.svg';
import tool from 'core/assets/svg/tool.svg';
import puzzlePiece from 'core/assets/svg/puzzle-piece.svg';
import lifeInsurance from 'core/assets/svg/life-insurance.svg';
import claim from 'core/assets/svg/claim.svg';
import pieChart from 'core/assets/svg/pie-chart.svg';

const iconMap = { portal, contact, pen, tool, puzzlePiece, lifeInsurance, claim, pieChart };

export default (appConfig.agencyPortalRoutes ?? []).map(({ icon, ...rest }) => ({
  ...rest,
  iconSrc: iconMap[icon]
}));
